import {NetworkTypeEnum, ProvidersMedicalGuide} from 'domain/usecases';
import {useServicePermission} from 'presentation/hooks/useServicePermission';
import {BookingTypeEnum} from 'presentation/pages/private/booking/constants';
import {useBookingConfirmationDrawer} from 'presentation/pages/private/booking/hooks/useBookingConfirmationDrawer';
import {useAccountInformation, useMediaQueries} from 'presentation/pages/private/hooks';
import {ServicesTypesEnum} from 'presentation/pages/private/hooks/useServicesListForShortcuts/types';

import {useContractStatus} from 'presentation/hooks';
import {IdentifierTelehealthEnum} from 'presentation/modules/guide/health/ui/pages/HealthGuide/types';
import {ServiceTypeEnum} from '../../../HealthGuideCard/types';
import {useHealthGuideCard} from '../../../HealthGuideCard/hooks/useHealthGuideCard';
import {useCongenereEligibilityStore} from 'presentation/pages/private/store/useCongenereEligibilityStore';

export function useHealthGuideDetails(provider?: ProvidersMedicalGuide, handleClose?: () => void) {
	const {isMobile} = useMediaQueries();
	const {setSelectedServiceType, handleOpenBookingConfirmationDrawer} =
		useBookingConfirmationDrawer();
	const {canOpenService} = useServicePermission();
	const {isContractSuspended} = useContractStatus();
	const {isEarlyAccess} = useAccountInformation();
	const {
		handleConfirmAndContinue,
		isSchedulingByMedicalGuideEnabled,
		isPending,
		handleOpenConfirmationDrawer,
		handleCloseConfirmationDrawer,
		openConfirmationDrawer,
		handleNavigateToBookingFlow,
	} = useHealthGuideCard({provider: provider as ProvidersMedicalGuide, showTradeName: false});
	const {congenereEligibility} = useCongenereEligibilityStore();
	const isAccreditedNetwork = provider?.tipoRede === NetworkTypeEnum.ACCREDITED_NETWORK;

	const isProviderAccreditedNetwork = provider?.tipoRede == null;

	const shouldShowAppointmentButton =
		provider?.tipo === ServiceTypeEnum.OFFICES_CLINICS &&
		!isProviderAccreditedNetwork &&
		!isAccreditedNetwork &&
		!isContractSuspended &&
		!isEarlyAccess &&
		!congenereEligibility;

	const isTelemedicine =
		provider?.tipoRede === NetworkTypeEnum.SELF_NETWORK &&
		provider?.nmBairro === IdentifierTelehealthEnum.DIGITAL_TELECONSULTATION;

	const handleSelectAppointment = async () => {
		const canAccessService = canOpenService(
			isTelemedicine ? ServicesTypesEnum.TELEHEALTH : ServicesTypesEnum.HEALTH,
		);

		if (!canAccessService) return;

		if (isSchedulingByMedicalGuideEnabled) {
			handleClose?.();
			await handleConfirmAndContinue();
			return;
		}

		setSelectedServiceType(
			isTelemedicine ? BookingTypeEnum.TELEHEALTH : BookingTypeEnum.HEALTH,
		);
		handleOpenBookingConfirmationDrawer();
	};

	return {
		handleSelectAppointment,
		shouldShowAppointmentButton,
		isMobile,
		isPending,
		handleOpenConfirmationDrawer,
		handleCloseConfirmationDrawer,
		openConfirmationDrawer,
		handleNavigateToBookingFlow,
	};
}
